import React, { useContext } from "react";
import { connect } from "react-redux";
import { useInterval } from "../hooks";
import ResponseTimeContainer from "./ReponseTimeContainer";
import CpuUsageChartSkeleton from "./CpuUsageChartSkeleton";
import MemUsageChartSkeleton from "./MemUsageChartSkeleton";
import DiskUsageChartSkeleton from "./DiskUsageChartSkeleton";
import ResponseTimeContainerSkeleton from "./ResponseTimeContainerSkeleton";
import CpuUsageChart from "./CpuUsageChart";
import MemUsageChart from "./MemUsageChart";
import DiskUsageChart from "./DiskUsageChart";
import { getSystemLoad, restartApplication, resetFactory, rebootSystem } from "./systemService";
import { showInfoToast } from "../validation/ToastContainer";
import { getConfirmPopup } from "../view/popup/PopupContainer";
import { PopupContext } from "../index";
import {
    RotateCcw,
    Power,
    RefreshCw
} from 'lucide-react';
import {
    finishLocalProcessingTask,
    startLocalProcessingTask
} from "../processing-tasks/processingTasksRegistry";

function ChartSection({ loading }) {

    const { setPopup } = useContext(PopupContext);

    useInterval(() => getSystemLoad(), 3000);

    const onRestartApplication = () => {
        showInfoToast('Restarting Application', 'Application');

        setPopup(
            getConfirmPopup('Are you sure?',
                'Octopus VAR Application Restart',
                () => onConfirm()
            )
        );

        const onConfirm = async () => {
            const processingTaskId = startLocalProcessingTask({
                id: `restart-application-${Date.now()}`,
                type: "System",
                title: "Restart Application"
            });
            try {
                await restartApplication();
            } finally {
                finishLocalProcessingTask(processingTaskId);
            }
        };
    }

    const onResetFactory = () => {
        showInfoToast('Reseting to Factory', 'Factory Reset');

        setPopup(
            getConfirmPopup('Are you sure?',
                'Octopus VAR Application Reset to Factory',
                () => onConfirm()
            )
        );

        const onConfirm = async () => {
            const processingTaskId = startLocalProcessingTask({
                id: `reset-factory-${Date.now()}`,
                type: "System",
                title: "Reset Factory"
            });
            try {
                await resetFactory();
            } finally {
                finishLocalProcessingTask(processingTaskId);
            }
        };
    }

    const onRebootSystem = () => {
        showInfoToast('Rebooting System', 'System');

        setPopup(
            getConfirmPopup('Are you sure?',
                'Octopus System Reboot',
                () => onConfirm()
            )
        );

        const onConfirm = async () => {
            const processingTaskId = startLocalProcessingTask({
                id: `reboot-system-${Date.now()}`,
                type: "System",
                title: "Reboot System"
            });
            try {
                await rebootSystem();
            } finally {
                finishLocalProcessingTask(processingTaskId);
            }
        };
    }

    return (
        <div className="container-fluid mt-4 space-y-6">
            {/* Action Buttons */}
            <div className="oct_sys-charts-actions-v2">
                <button
                    onClick={onRestartApplication}
                    className="oct_btn-export-v2"
                >
                    <RefreshCw className="w-4 h-4 mr-2" />
                    Restart Application
                </button>

                <button
                    onClick={onResetFactory}
                    className="oct_btn-export-v2"
                >
                    <RotateCcw className="w-4 h-4 mr-2" />
                    Reset Factory
                </button>

                <button
                    onClick={onRebootSystem}
                    className="oct_btn-export-v2"
                >
                    <Power className="w-4 h-4 mr-2" />
                    Reboot System
                </button>
            </div>

            {/* System Monitoring Cards */}
            <div className="mt-4">
                {loading && (
                    <div className="oct_sys-charts-grid-v2">
                        <CpuUsageChartSkeleton />
                        <MemUsageChartSkeleton />
                        <DiskUsageChartSkeleton />
                        <ResponseTimeContainerSkeleton />
                    </div>
                )}
                {!loading &&
                    <div className="oct_sys-charts-grid-v2">
                        <CpuUsageChart />
                        <MemUsageChart />
                        <DiskUsageChart />
                        <ResponseTimeContainer />
                    </div>
                }
            </div>
        </div>
    )

}

function mapStateToProps(state) {
    return { loading: state.systemPage.loading };
}

export default connect(mapStateToProps)(ChartSection);
